export const isDownloadExpired = (createdAt: string): boolean => {
 if (!createdAt) return false;
 const purchaseDate = new Date(createdAt);
 const now = new Date();
 const diffTime = Math.abs(now.getTime() - purchaseDate.getTime());
 const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
 return diffDays > 30;
};
